import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import internetOfEfficiencyLogo from './logos/internetOfEfficiencyLogo.svg';
import Timer from './Timer';
import { withStyles } from 'material-ui/styles';
import { LinearProgress } from 'material-ui/Progress';

const styles = theme => ({
  app__bar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    backgroundColor: theme.appBarBg,
    height: '3rem'
  },
  app__logo: {
    display: 'flex',
    alignItems: 'center',
    height: '3rem',
    marginRight: '0.8rem'
  },
  linearProgressLoading: {
    position: 'fixed',
    left: 0,
    right: 0
  }
});

const isLoading = ({ loading }) =>
  Object.keys(loading).some(key => loading[key]);

const SiteHeader = ({ show, timezone, loading, classes }) => {
  if (!show) {
    return null;
  }

  return (
    <header className={classes.app__bar}>
      {isLoading({ loading }) ? (
        <LinearProgress className={classes.linearProgressLoading} />
      ) : null}
      <div className="bar__content">
        <Link to="/" className={classes.app__logo}>
          <img
            src={internetOfEfficiencyLogo}
            className="app__logo-image"
            alt="Internet of Efficiency"
          />
        </Link>
        <div className="bar__nav">
          <NavLink
            className="bar__nav-item"
            activeClassName="bar__nav-item--active"
            to="/sites"
          >
            Site Overview
          </NavLink>
          <div className="bar__nav-item" style={{ marginLeft: 'auto' }}>
            <Timer timezone={timezone} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default withStyles(styles, { name: 'SiteHeader' })(SiteHeader);



// WEBPACK FOOTER //
// ./src/components/SiteHeader.js